import lodash from 'lodash';
const { get } = lodash;

export default { fromHNode, getMql, getUriComponent, getJavaScriptFilter };

function fromHNode({ propertyName, pattern, ignoreCase }) {
    return { propertyName, pattern, ignoreCase };
}

function getMql({ matchesPattern }) {
    if (!matchesPattern) return;
    const { propertyName, pattern, ignoreCase } = matchesPattern;
    // LokiJS uses [pattern, flags]; searchCriteria translates this for MongoDB.
    return { [propertyName]: { $regex: [pattern, ignoreCase ? 'i' : ''] } };
}

function getUriComponent(filters) {
    const criteria = getMql(filters);
    if (!criteria) return;
    const { propertyName, pattern, ignoreCase } = filters.matchesPattern;
    return { criteria: { [propertyName]: { $regex: pattern, $options: ignoreCase ? 'i' : '' } } };
}

function getJavaScriptFilter({ propertyName, pattern, ignoreCase }) {
    const expression = new RegExp(pattern, ignoreCase ? 'i' : '');
    return record => expression.test(String(get(record, propertyName, '')));
}
